<template>
  <div
    class="store-info"
  >
    <div class="row">
      <div class="col store-info__header">
        <div class="store-info__heading">
          Din butik
        </div>
        <div>
          <button
            class="button--secondary button--32"
            @click="$emit('changeStore')"
          >
            Ändra
          </button>
        </div>
      </div>
    </div>
    <div class="store-info__store-name">
      <div class="col">
        <h3>
          {{ store.name }}
        </h3>
      </div>
    </div>
    <div class="row ">
      <div class="store-info__store-delivery">
        <store-delivery-wrapper
          :title="'Leveranssätt'"
          :selected-delivery-method="selectedDeliveryMethod"
        />
        <store-delivery-wrapper
          :title="'Betalsätt'"
          :has-pre-payment="store.hasPrePayment"
          :has-store-payment="store.hasStorePayment"
        />
      </div>
    </div>
  </div>
</template>

<script>
import '#/Illustrative/Location'
import '#/Delivery/CollectinStore'
import '#/Delivery/HomeDelivery'
import '#/Controls/Check'
import '#/Logos/ICA'
import '#/Logos/ICA-Nara'
import '#/Logos/ICA-Supermarket'
import '#/Logos/ICA-Kvantum'
import '#/Logos/ICA-Maxi-Stormarknad'
import { mapMutations, mapState } from 'vuex'
import storeDeliveryWrapper from '@/vue/components/groceryBagComponents/storeDeliveryWrapper.vue'

export default {
  components: {
    'store-delivery-wrapper':storeDeliveryWrapper
  },
  data () {
    return {
      selectedStore: {},
      renderStore: null,
    }
  },
  computed: {
    ...mapState(['store', 'selectedDeliveryMethod'])
  },
  watch: {
    store (newStore) {
      this.renderStore = newStore
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.store) {
        this.renderStore = this.store
      }
      if (!this.store && this.selectedDeliveryMethod) {
        this.clearSelectedStore()
      }
    })
  },
  methods: {
    ...mapMutations(['CLEAR_STORE', 'CLEAR_DELIVERY_METHOD']),
    clearSelectedStore () {
      this.CLEAR_STORE()
      this.CLEAR_DELIVERY_METHOD()
    }
  },
}
</script>

<style lang="scss">
.store-info {
  &__header {
    display: flex;
    justify-content: space-between;
  }

  &__heading {
    @include font(text, 2, "black");

    text-transform: uppercase;
  }

  &__description {
    @include font(text, 3, "light");

    margin-bottom: 1rem;
    margin-top: 0;
    padding: 0 2rem;
  }

  &__store-name {
    text-align: left;
    margin-left: 30%;

    h3 {
      @include font(rubrik, 1, "bold");

      margin-top: 0;
      margin-bottom: 1rem;
      color: $color-red;
    }

    @include media-breakpoint-up(md) {
      text-align: center;
      margin: 0;

      h3 {
        @include font(rubrik, 2, "bold");
      }
    }
  }

  &__store-delivery {
    display: flex;
    flex-direction: column;
    flex: 1 1 0%;
    justify-content: center;
    border-top: 1px solid $color-grey-special;
    padding-top: 1rem;
    margin: 0 0.5rem;

    .store-delivery-wrapper {
      padding: 0 0.5rem;

      &:first-child {
        margin-bottom: 1rem;
      }
    }

    @include media-breakpoint-up(md) {
      flex-direction: row;

      .store-delivery-wrapper:first-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
